import { createContext } from "react";

const StripeContext = createContext(null);
export default StripeContext;
